
import { createClient } from '@supabase/supabase-js'
import { apisupaBaseUrl, supabaseToken_id } from '../utils/constant/apigateways';

const supabaseUrl = apisupaBaseUrl
const supabaseKey = supabaseToken_id

const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;